import { render, staticRenderFns } from "./PostGallerySwitch.vue?vue&type=template&id=0b7dea9e&scoped=true&"
import script from "./PostGallerySwitch.vue?vue&type=script&lang=ts&"
export * from "./PostGallerySwitch.vue?vue&type=script&lang=ts&"
import style0 from "./post_gallery_switch.scss?vue&type=style&index=0&id=0b7dea9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7dea9e",
  null
  
)

export default component.exports